// extracted by mini-css-extract-plugin
export var modalFooter = "_iz-0";